'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MessageDocument = exports.MessageBubble = exports.Message = exports.Conversation = exports.MessageGroup = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _Message = require('./Message');

Object.defineProperty(exports, 'Message', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Message).default;
  }
});
Object.defineProperty(exports, 'MessageBubble', {
  enumerable: true,
  get: function get() {
    return _Message.MessageBubble;
  }
});

var _MessageDocument = require('./MessageDocument');

Object.defineProperty(exports, 'MessageDocument', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_MessageDocument).default;
  }
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

require('./styles.sass');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * A message group.
 *
 * @param  {Boolean} options.mine
 */
var MessageGroup = exports.MessageGroup = function MessageGroup(_ref) {
  var mine = _ref.mine,
      children = _ref.children;
  return _react2.default.createElement(
    'div',
    {
      className: (0, _classnames2.default)('MessageGroup')
    },
    children
  );
};

MessageGroup.propTypes = {
  mine: _propTypes2.default.bool,
  children: _propTypes2.default.node
};

/**
 * Conversation component.
 */

var Conversation = exports.Conversation = function (_React$Component) {
  (0, _inherits3.default)(Conversation, _React$Component);

  function Conversation() {
    (0, _classCallCheck3.default)(this, Conversation);
    return (0, _possibleConstructorReturn3.default)(this, (Conversation.__proto__ || (0, _getPrototypeOf2.default)(Conversation)).apply(this, arguments));
  }

  (0, _createClass3.default)(Conversation, [{
    key: 'render',
    value: function render() {
      // const adminStyle = {
      //   backgroundColor: '#40c4ea'
      // };
      // const theirAvatar = 'https://scontent.xx.fbcdn.net/hprofile-xpl1/v/t1.0-1/p50x50/12033054_10153170208302816_4236135416063891193_n.jpg?oh=be70b28cc8be91ef4e2764c7ad635318&oe=575DA0A5';
      // const adminAvatar = 'https://media.licdn.com/mpr/mpr/shrinknp_200_200/AAEAAQAAAAAAAAPxAAAAJDQxODgzMTVjLTBkNTItNGI5Mi05N2E5LWUzMDY0ZDUyMTg0ZA.jpg';
      return _react2.default.createElement(
        'div',
        { className: 'Conversation' },
        this.props.children
      );
    }
  }]);
  return Conversation;
}(_react2.default.Component);

Conversation.propTypes = {
  children: _propTypes2.default.node
};
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@taxfyle/web-commons/lib/components/Conversation/index.js
// module id = 380
// module chunks = 0